module.exports = __webpack_public_path__ + "static/media/calendar_items.63791c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/calendar_items.png
// module id = 247
// module chunks = 0